/**
 *
 * Asynchronously loads the component for AssetOverview
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AssetOverview = lazyLoad(
  () => import('./index'),
  module => module.AssetOverview,
);
